import Cookies from 'js-cookie'

// 普通token
// const TokenKey = 'token'

export function getToken() {
  // return Cookies.get(TokenKey)
  return sessionStorage.getItem('token')
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token, { expires: 7 })
  return sessionStorage.setItem('token', token)
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  return sessionStorage.removeItem('token')
}

// 场馆token
// const VenueTokenKey = 'venueToken'

export function getVenueToken() {
  // return Cookies.get(VenueTokenKey)
  return sessionStorage.getItem('venueToken')
}

export function setVenueToken(token) {
  // return Cookies.set(VenueTokenKey, token, { expires: 7 })
  return sessionStorage.setItem('venueToken', token)
}

export function removeVenueToken() {
  // return Cookies.remove(VenueToken)
  return sessionStorage.removeItem('VenueToken')
}
